import 'scss/services/xftrans.scss'
import 'babel-polyfill'
import { config } from 'config'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { getItsResult } from 'js/api/services'
import 'js/libs/gt'
import { Base64 } from 'js-base64'

var trans = {
  config: {},
  data: {
    select: '',
    from: 'cn',
    fromText: '中文（简体）',
    to: 'en',
    toText: '英语'
  },
  bindEvent: function () {
    var self = this
    $(document).on('click', function () {
      $('.Lbox').hide()
    })
    $(document).find('.Lbox').hover(function () {}, function () {
      $('.Lbox').hide()
    })
    $(document).find('.trans-from-button').on('click', function (e) {
      e.stopPropagation()
      self.methods.handleTransBtnClick($(this), $('.Lbox-from'), self.data.from)
    })
    $(document).find('.trans-to-button').on('click', function (e) {
      e.stopPropagation()
      self.methods.handleTransBtnClick($(this), $('.Lbox-to'), self.data.to)
    })
    $(document).find('.Lbox .Lbox-content li').on('click', function (e) {
      e.stopPropagation()
      if ($(this).hasClass('selected')) {
        $('.Lbox').hide()
        return false
      }
      self.methods.selectLanguage($(this).attr('value'), $(this).html())
    })
    $(document).find('#trans_text').on('keyup', function () {
      var len = $('#trans_text').val().length
      $(document).find('.trans-text-num').empty().html(`${len}/200`)
    })
    $(document).find('.form-to-icon').on('click', function () {
      $('#trans_text').val('')
      $(document).find('.io-output .output').empty()
      self.methods.exchangeLanguage()
    })
  },
  methods: {
    handleTransBtnClick ($this, $Lbox, data) {
      trans.data.select = $this.attr('value')
      $('.Lbox').hide()
      $Lbox.find('.Lbox-content li').removeClass('selected')
      $Lbox.find('.Lbox-content').find(`[value=${data}]`).addClass('selected')
      $Lbox.show()
    },
    selectLanguage (val, text) {
      $('.Lbox').hide()
      if (trans.data.select === 'trans_from_lan') {
        trans.data.from = val
        trans.data.fromText = text
        $('.trans-from-button span').replaceWith(`<span>${text}</span>`)
        if (val !== 'cn') {
          trans.data.to = 'cn'
          trans.data.toText = '中文（简体）'
          $('.trans-to-button span').replaceWith(`<span>中文（简体）</span>`)
        }
      } else {
        trans.data.to = val
        trans.data.toText = text
        $('.trans-to-button span').replaceWith(`<span>${text}</span>`)
        if (val !== 'cn') {
          trans.data.from = 'cn'
          trans.data.fromText = '中文（简体）'
          $('.trans-from-button span').replaceWith(`<span>中文（简体）</span>`)
        }
      }
    },
    exchangeLanguage () {
      var temp = trans.data.from
      var tempText = trans.data.fromText
      trans.data.from = trans.data.to
      trans.data.to = temp
      trans.data.fromText = trans.data.toText
      trans.data.toText = tempText
      $('.trans-from-button span').replaceWith(`<span>${trans.data.fromText}</span>`)
      $('.trans-to-button span').replaceWith(`<span>${trans.data.toText}</span>`)
    },
    getResult (val) {
      $.mask()
      $(document).find('.io-output .output').empty()
      var params = {
        from: trans.data.from,
        to: trans.data.to,
        text: Base64.encode($.trim($('#trans_text').val())),
        challenge: val.geetest_challenge,
        validate: val.geetest_validate,
        seccode: val.geetest_seccode
      }
      getItsResult(params).then(function (res) {
        $.mask('hide')
        if (res.code === 0 || res.code === '0') {
          var str = `<div class="result">${res.data.result.trans_result.dst}</div>`
          $(document).find('.io-output .output').html(str)
        } else {
          $.alerts.alert(res.desc)
        }
      }).catch(function (errMsg) {
        $.mask('hide')
        $.alerts.alert(errMsg)
      })
    },
    // 极验Api1
    geetestApi1: function () {
      var self = trans
      $.ajax({
        url: '/herapi/plug/validate?t=' + (new Date()).getTime(),
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 调用 initGeetest 进行初始化
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
          initGeetest({
            // 以下 4 个配置参数为必须，不能缺少
            gt: data.data.gt,
            challenge: data.data.challenge,
            offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机

            product: 'bind', // 产品形式，包括：float，popup
            width: '300px'
            // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
          }, function (captchaObj) {
            captchaObj.onReady(function () {
            }).onSuccess(function () {
              self.result = captchaObj.getValidate()
              if (!self.result) {
                return $.alerts.alert('请完成验证')
              }
              trans.methods.getResult(self.result)
            })
            $('#taste-button').click(function () {
              var text = $.trim($('#trans_text').val())
              if (!text) {
                $.alerts.alert('请输入需要翻译的内容')
              } else {
                captchaObj.verify()
              }
            })
          })
        }
      })
    }
  },
  init: function () {
    this.bindEvent()
  }
}

$(function () {
  trans.init()
  trans.methods.geetestApi1()
  serviceQA()
  serviceTopbar()
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).attr('package-id')
    let params = {
      wareId: '7004',
      packageId: packageId,
      serviceName: '机器翻译',
      businessId: 'its'
    }
    goServiceBuy(params, {
      btnStr: ['7004001'].indexOf(packageId) > -1 ? '领取' : '购买'
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/xftrans.js